import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BreadCrumb } from 'src/app/models/common/bread-crumb';
import { PageHeader } from 'src/app/models/common/page-header';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { HeaderService } from 'src/app/system-common/services/header.service';

import { SettingService } from 'src/app/system-common/services/setting.service';
import { SearchResponseIO } from 'src/app/models/search-responseIO';
import { CompensationService } from '../services/compensation.service';

@Component({
  selector: '',
  template: '',
})
export class CommissionDetailsSearchHandler extends BaseSearchComponent<CompensationService> implements OnInit {
  isAdvanceSearchDisplayed: boolean;
  public searchName: string;

  constructor(
    public service: CompensationService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ) {
    super(service, router, headerService);
    // this.addLink = '/search-commission-details';
    //this.service.isAuditButtonClicked = false;
    //this.isSearchFilteredByCriteria = true;
  }

  ngOnInit() {
    super.ngOnInit();

    this.searchName = 'SearchCommissionDetails';

    //this.service.forAuditSearchList = false;
    this.settingService.removeSessionStorage('AuditChanges');
    this.isAdvanceSearchDisplayed = true;
  }

  protected getBreadCrumbList(): BreadCrumb[] {
    return [
      {
        id: 'Home',
        link: '/home',
      },
      {
        id: 'Search',
      },
    ];
  }

  protected getMoreOptionList(): any[] {
    return [
      {
        id: 'Edit',
        link: '/search-production-details',
      },
      {
        id: 'Delete',
        link: '/search-commission-details',
      },
      {
        id: 'Audit',
        link: '/search-commission-details',
      },
      {
        id: 'Close',
        link: '/search-commission-details',
      },
      {
        id: 'Profile',
        link: '/profile',
      },
    ];
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    // header.title = 'Commission Details';
    header.title = this.settingService.getLabelValue('commissionDetails');
    return header;
  }

  Edit_click(optionDetails: { button_id; link; ref_id }) {
    let link: string;
    console.log(optionDetails.ref_id);
    link = optionDetails.link.toString().replace(':id', optionDetails.ref_id);
    this.router.navigate([link], optionDetails.ref_id);
  }

  Audit_click(buttonClicked: { button_id: string; link: string; ref_id }) {
    this.service.id = buttonClicked.ref_id;
    setTimeout(() => {
      //this.service.isAuditButtonClicked = true;
    }, 10);
  }

  Profile_click(optionDetails: { button_id; link; ref_id }) {
    let link: string;
    console.log(optionDetails.ref_id);
    link = optionDetails.link.toString().replace(':id', optionDetails.ref_id);
    this.router.navigate([link], optionDetails.ref_id);
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
  }
}
